"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.5 12a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z", stroke: "inherit", fill: "inherit" }), "RadioButtonUnchecked");
//# sourceMappingURL=RadioButtonUnchecked.js.map